import { render } from "./BillingInvoicesPage.vue?vue&type=template&id=5d3c7f82&scoped=true"
import script from "./BillingInvoicesPage.vue?vue&type=script&lang=js"
export * from "./BillingInvoicesPage.vue?vue&type=script&lang=js"

import "./BillingInvoicesPage.vue?vue&type=style&index=0&id=5d3c7f82&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3c7f82"]])

export default __exports__